import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Link } from 'react-router-dom';

function GalleryFour() {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImage, setModalImage] = useState('');
    const [exploreData, setExploreData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Fetch explore section data from API
    useEffect(() => {
        const fetchExploreData = async () => {
            try {
                const response = await fetch('https://dzsoftech.net/tours/api/airbnb/explore/');
                const data = await response.json();
                if (data.results && data.results.length > 0) {
                    setExploreData(data.results[0]);
                }
            } catch (error) {
                console.error('Error fetching explore data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchExploreData();
    }, []);

    // Function to open the modal with the selected image
    const openModal = (imageSrc, event) => {
        event.preventDefault(); // Prevent default link behavior
        setModalImage(imageSrc);
        setIsModalOpen(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setIsModalOpen(false);
    };

    // Fallback images for empty slots
    const fallbackImages = [
        '/assets/img/gallery/gallery_8_1.jpg',
        '/assets/img/gallery/gallery_8_2.jpg',
        '/assets/img/gallery/gallery_8_3.jpg',
        '/assets/img/gallery/gallery_8_4.jpg',
        '/assets/img/gallery/gallery_8_5.jpg',
        '/assets/img/gallery/gallery_8_6.jpg',
        '/assets/img/gallery/gallery_8_7.jpg',
        '/assets/img/gallery/gallery_8_8.jpg',
    ];

    // Get gallery images (API images + fallback images to fill 8 slots)
    const getGalleryImages = () => {
        if (!exploreData || !exploreData.gallery_images) {
            return fallbackImages;
        }
        
        const apiImages = exploreData.gallery_images.map(img => img.url);
        const remainingSlots = 8 - apiImages.length;
        
        if (remainingSlots > 0) {
            return [...apiImages, ...fallbackImages.slice(0, remainingSlots)];
        }
        
        return apiImages.slice(0, 8); // Take only first 8 if more than 8
    };

    const galleryImages = getGalleryImages();

    if (loading) {
        return (
            <div className="overflow-hidden space" id="gallery-sec">
                <div className="container-fuild">
                    <div className="title-area mb-30 text-center">
                        <span className="sub-title">Explore Us</span>
                        <h2 className="sec-title">Loading...</h2>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <div className="overflow-hidden space" id="gallery-sec">
            <div className="container-fuild">
                <div className="title-area mb-30 text-center">
                    <span className="sub-title">{exploreData?.subtitle || "Explore Us"}</span>
                    <h2 className="sec-title">{exploreData?.title || "A truly exceptional experience"}</h2>
                </div>
                <div className="row gy-4 gallery-row4">
                    {galleryImages.map((imageSrc, index) => (
                        <div key={index} className="col-auto">
                            <div className="gallery-box style5">
                                <div className="gallery-img global-img">
                                    <img 
                                        src={imageSrc} 
                                        alt={`Gallery image ${index + 1}`}
                                        onClick={(e) => openModal(imageSrc, e)}
                                        onError={(e) => {
                                            // Fallback to default image if API image fails to load
                                            e.target.src = fallbackImages[index] || fallbackImages[0];
                                        }}
                                    />
                                    <Link
                                        to={imageSrc}
                                        className="icon-btn popup-image"
                                        onClick={(e) => openModal(imageSrc, e)}
                                    >
                                        <i className="fal fa-magnifying-glass-plus" />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Modal isOpen={isModalOpen} closeModal={closeModal} imageSrc={modalImage} />
        </div>
    )
}

export default GalleryFour
